import API from './api';

export default {

    signIn: (token) => API({
        url: 'accounts/login/2fa',
        method: 'POST',
        noAuth: true,
        json: { token }
    }),

    verifyTwoFa: (token, challengeId, code) => API({
        url: 'accounts/login/verify-2fa',
        method: 'POST',
        noAuth: true,
        json: { token, challenge_id: challengeId, code: (code || '').trim() }
    }),

    signOut: () => API({
        url: 'accounts/logout',
        method: 'POST',
        noAuth: true,
    }),

    getCurrentAccount: () => API({
        url: 'accounts/current',
        method: 'GET',
    }),

    getCurrentAccountRosterSettings: () => API({
        url: 'accounts/current/settings/roster',
        method: 'GET',
    }),

    patchAccountRosterSettings: (columns) => API({
        url: `accounts/current/settings/roster`,
        method: 'PATCH',
        json: { columns },
    }),

    getAccountOrganizations: () => API({
        url: 'account/organization_roles',
        method: 'GET',
    }),

    register: (token, email, password, organization_name, beta, inviteCode, firstName, middleName, lastName, programId) => API({
        url: 'accounts',
        method: 'POST',
        json: {
            token,
            email,
            password,
            organization_name,
            beta,
            invite_code: inviteCode,
            athlete_invite: inviteCode,
            firstName,
            middleName,
            lastName,
            program_id: programId
        }
    }),
    
};
